import type { FC, ReactNode } from 'react'
import type { StoreSettings } from '@/types'

import { Truck } from 'lucide-react'
import { cn } from '@/lib/utils'
import { remainingForFreeShipping } from '@/lib/pricing'
import { Amount } from '@/components/store/price'

interface FreeShippingMeterProps {
    settings: Pick<StoreSettings, 'shipping_cost' | 'free_shipping_threshold'> | null
    amount: number
    className?: string
}

const FreeShippingMeter: FC<FreeShippingMeterProps> = ({ settings, amount, className }): ReactNode => {
    if (!settings || settings.free_shipping_threshold <= 0 || amount <= 0) return null

    const remaining = remainingForFreeShipping(settings, amount)
    const progress = Math.min(100, Math.round((amount / settings.free_shipping_threshold) * 100))

    return (
        <div className={cn('rounded-xl bg-muted/70 p-3.5', className)}>
            <p className='flex items-center gap-2 text-xs leading-6'>
                <Truck className='size-4 shrink-0' aria-hidden='true' />

                {remaining > 0 ? (
                    <span>
                        <Amount value={remaining} className='text-xs' unitClassName='text-[11px]' />
                        {' '}
                        تا ارسال رایگان باقی مانده است.
                    </span>
                ) : (
                    <span className='font-medium'>
                        ارسال این سفارش رایگان است.
                    </span>
                )}
            </p>

            <div className='mt-2.5 h-1.5 overflow-hidden rounded-full bg-background' role='progressbar' aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100} aria-label='پیشرفت تا ارسال رایگان'>
                <div className='h-full rounded-full bg-foreground transition-[width] duration-500' style={{ width: `${progress}%` }} />
            </div>
        </div>
    )
}

export default FreeShippingMeter
